import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentNumberingSection from './DocumentNumberingSection';
import { SettingsSheet } from './sheet';

/**
 * Ταμείο → «Αρίθμηση παραστατικών» (13/10/2026, ως τότε μέσα στα «Στοιχεία επιχείρησης»): οι σειρές και
 * οι αριθμοί κάθε τύπου παραστατικού (Oxygen) και η αλλαγή σειράς σε όλα μαζί. Οι ενέργειες εφαρμόζονται
 * αμέσως, με επιβεβαίωση όπου χρειάζεται — καμία μπάρα «Αποθήκευση». Διάταξη «Φύλλο»: «Αλλαγή σειράς σε
 * όλα» και μία ενότητα ανά τύπο παραστατικού, με ευρετήριο.
 */
const DocumentNumberingPage: React.FC = () => {
  const { t } = useTranslation(['settings']);
  return (
    <SettingsSheet eyebrow={t('settings:nav.groups.register')} title={t('settings:ecr.pageTitle')} subtitle={t('settings:ecr.pageSubtitle')}>
      <DocumentNumberingSection />
    </SettingsSheet>
  );
};

export default DocumentNumberingPage;
